/* eslint-disabled */
import Branch from "./Branch";
import Reduction from "./Reduction";
import EngineMethod from "./EngineMethod";
import ReductionModelExtend from "@/entity/extends/ReductionModelExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class ReductionModel extends ReductionModelExtend {

public id!: number;
public label = '';
public code = '';
public branch!: Branch;
public isEnable!: boolean;
public reductions: Array<Reduction> = [];
public ranking!: number;
public method!: EngineMethod;
public requiredRoles= [];
public deletedAt?: Date;

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
       this.code= object.code;
this.branch = (object.branch instanceof Branch) ? object.branch : object.branch ? new Branch(object.branch) : object.branch;
       this.isEnable= object.isEnable;
            hydrateCollection(object.reductions, Reduction, this.reductions);
       this.ranking= object.ranking;
this.method = (object.method instanceof EngineMethod) ? object.method : object.method ? new EngineMethod(object.method) : object.method;
       this.requiredRoles= object.requiredRoles;
       if(object.deletedAt){
           this.deletedAt= new Date(object.deletedAt);
       }
      }
      this.postConstruct()
  }

}
